import PropTypes from 'prop-types';
import React from 'react';
import debounce from 'lodash/debounce';

const AXIS = {
  X: 'X',
  Y: 'Y',
};

export class FluidRatio extends React.Component {
  constructor() {
    super(...arguments);
    this.handleResize = debounce(this.handleResize.bind(this), 150);
    this.state = {
      hasComputed: false,
      width: 0,
      height: 0,
    };
  }

  getComputedDimensions({axis, x, y}) {
    if (axis === AXIS.X) {
      const {width} = this.refs.container.getBoundingClientRect();

      return {
        width,
        height: width * (y / x),
      };
    }

    const {height} = this.refs.container.getBoundingClientRect();

    return {
      height,
      width: height * (x / y),
    };
  }

  UNSAFE_componentWillMount() {
    this._width = window.innerWidth;
  }

  UNSAFE_componentWillReceiveProps(next) {
    this.setState(this.getComputedDimensions(next));
  }

  componentDidMount() {
    this.setState({
      ...this.getComputedDimensions(this.props),
      hasComputed: true,
    });

    window.addEventListener('resize', this.handleResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }

  handleResize() {
    if (this._width === window.innerWidth) return null;
    this.setState(
      {
        hasComputed: false,
      },
      () => {
        this.setState({
          hasComputed: true,
          ...this.getComputedDimensions(this.props),
        });
      }
    );

    this._width = window.innerWidth;
  }

  render() {
    return (
      <div ref="container">
        {this.props.children(
          this.state.width,
          this.state.height,
          this.state.hasComputed
        )}
      </div>
    );
  }
}

FluidRatio.AXIS = AXIS;

FluidRatio.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  axis: PropTypes.oneOf(Object.keys(AXIS)),
  children: PropTypes.func.isRequired,
};

FluidRatio.defaultProps = {
  x: 3,
  y: 4,
  axis: AXIS.X,
};
